import { getElementById } from '@dni-utils/get-element-by-id'
import { Box } from '@pets-ui/Box/Box'
import { Container } from '@pets-ui/Container/Container'
import { HStack } from '@pets-ui/HStack/HStack'
import { Paper } from '@pets-ui/Paper/Paper'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useResponsive } from '@pets-ui/useResponsive/useResponsive'
import { useEffect, useRef, type PropsWithChildren } from 'react'
import { WpMyAccountSidebar, type WpMyAccountSidebarProps } from './WpMyAccountSidebar'
import { WpMyAccountSidebarDropdown } from './WpMyAccountSidebarDropdown'

export interface LayoutMyAccountProps {
  showWpContent?: boolean
  showSidebarDropdown?: boolean
  menuItem: WpMyAccountSidebarProps['menuItem']
}

export const LayoutMyAccount = (props: PropsWithChildren<LayoutMyAccountProps>) => {
  const { children, showWpContent, showSidebarDropdown = true, menuItem } = props
  const mainRef = useRef<HTMLDivElement>(null)
  const isInitialized = useRef(false)
  const isMobile = useResponsive('wordpressMobile')

  useEffect(() => {
    if (!showWpContent || isInitialized.current) return
    const wpContent = getElementById('wp-render-content')
    if (!wpContent) return
    const mainEl = mainRef.current
    wpContent.style.display = 'block'
    mainEl?.appendChild(wpContent)
    isInitialized.current = true
  }, [showWpContent])

  useEffect(() => {
    const styles = `
    #main {
      min-height: 100vh;
      background-color: ${colors.grey100};
      position: relative;
    }`.replace(/\n/g, '')
    const styleSheet = document.createElement('style')
    styleSheet.innerText = styles
    document.head.append(styleSheet)

    return () => {
      if (styleSheet) {
        document.head.removeChild(styleSheet)
      }
    }
  }, [])

  return (
    <Container maxWidth={1080}>
      {isMobile && showSidebarDropdown && <WpMyAccountSidebarDropdown menuItem={menuItem} />}
      {/** padding 在 mobile 暫時不動，會造成會員中心跑版 */}
      <HStack gap={4} p={5} flexWrap="nowrap">
        {!isMobile && <Box flexShrink={0} width={200}><WpMyAccountSidebar menuItem={menuItem} /></Box>}
        {showWpContent
          ? (
            <Paper rootRef={mainRef} p={4} elevation={0} borderRadius={8} flex="1">
              {children}
            </Paper>
          )
          : children}
      </HStack>
    </Container>
  )
}
